export const MODULE_TRANSLATION_ALLOWLIST = {
    'ar': [
        'opd:03xxxxxxxxx',
        'pharmacy:medipak',
        'lab:hb',
        'lab:g_dl',
        'lab:cbc',
        'lab:sysmex_xn_550',
        'lab:hl7_v2_oru_r01',
        'lab:astm_e1394',
        'lab:hgb',
        'lab:03xxxxxxxxx',
        'lab:cobas_e411',
    ],
    'es': [
        'admin:ip',
        'admin:hash',
        'admin:x_ms',
        'admin:x_bytes',
        'admin:logo',
        'admin:manual',
        'admin:roles',
        'admin:2fa',
        'billing:total',
        'billing:plan',
        'billing:base',
        'opd:spo',
        'opd:500_mg',
        'opd:paracetamol',
        'opd:min',
        'opd:no',
        'opd:kb',
        'opd:stat',
        'opd:03xxxxxxxxx',
        'opd:total',
        'pharmacy:total',
        'pharmacy:500_mg_5_ml',
        'pharmacy:medipak',
        'pharmacy:subtotal',
        'pharmacy:rx',
        'lab:stat',
        'lab:panel',
        'lab:total',
        'lab:tat',
        'lab:panel_2',
        'lab:hb',
        'lab:g_dl',
        'lab:manual',
        'lab:sysmex_xn_550',
        'lab:hl7_v2_oru_r01',
        'lab:astm_e1394',
        'lab:hgb',
        'lab:03xxxxxxxxx',
        'lab:normal',
        'lab:cv',
        'lab:cobas_e411',
        'ipd:spo',
        'ipd:final',
        'ipd:plan',
        'billing:x_min',
        'billing:nphies',
        'opd:channel_nphies',
        'opd:channel_manual',
        'lab:compatible',
        'lab:incompatible',
        'lab:bb_marker_hepatitis_b',
        'lab:bb_marker_hepatitis_c',
        'lab:bb_marker_malaria',
    ],
    'ur-Latn': [
        'admin:doctor',
        'billing:nphies',
        'billing:x_services',
        'billing:appointment',
        'opd:calendar',
        'opd:service',
        'opd:appointment',
        'opd:channel_nphies',
        'admin:online_cloud',
        'admin:production_live',
        'admin:size',
        'admin:certification_session',
        'admin:pattern',
        'admin:settings',
        'admin:username',
        'admin:email',
        'billing:note',
        'billing:billing',
        'billing:invoice',
        'billing:services',
        'billing:packages',
        'billing:code',
        'billing:service',
        'billing:tax',
        'billing:package',
        'billing:tax_2',
        'billing:plan',
        'billing:branch',
        'billing:rate',
        'billing:doctor',
        'billing:visit',
        'billing:charge_item',
        'billing:phone',
        'billing:a4_bill',
        'billing:credit_note',
        'billing:charges',
        'billing:rate_2',
        'billing:vat',
        'billing:voucher',
        'billing:credit_notes',
        'billing:mrn',
        'billing:token',
        'billing:slip',
        'billing:bill',
        'billing:bill_x',
        'billing:credit_note_x',
        'billing:thermal',
        'billing:panel',
        'billing:doctors',
        'billing:doctors_x',
        'billing:setting',
        'billing:bills',
        'billing:balance_sheet',
        'billing:trial_balance',
        'billing:debit',
        'billing:debit_2',
        'billing:credit_2',
        'billing:items',
        'opd:token_x',
        'opd:appointments',
        'opd:token',
        'opd:doctor',
        'opd:visit',
        'opd:slip',
        'opd:note',
        'opd:follow_up',
        'opd:certificates',
        'opd:laboratory',
        'opd:imaging',
        'opd:laboratory_2',
        'opd:imaging_2',
        'opd:allergies',
        'opd:bmi',
        'opd:orders',
        'opd:forms',
        'opd:attachments',
        'opd:mobile',
        'opd:vitals',
        'opd:vitals_2',
        'opd:branch',
        'opd:notes',
        'opd:conference',
        'opd:order',
        'opd:procedure',
        'opd:test',
        'opd:imaging_3',
        'opd:serum_ferritin_vitamin_d',
        'opd:studies',
        'opd:phone',
        'opd:03xxxxxxxxx',
        'opd:blood_group',
        'opd:coverage',
        'opd:billing',
        'opd:invoice',
        'opd:mrn_x',
        'opd:email',
        'opd:mrn',
        'pharmacy:store',
        'pharmacy:batch',
        'pharmacy:product',
        'pharmacy:note',
        'pharmacy:quarantine_recall',
        'pharmacy:recall',
        'pharmacy:quarantine',
        'pharmacy:supplier',
        'pharmacy:products',
        'pharmacy:stock',
        'pharmacy:suppliers',
        'pharmacy:purchase_orders',
        'pharmacy:code',
        'pharmacy:pack',
        'pharmacy:batches',
        'pharmacy:units',
        'pharmacy:service_item',
        'pharmacy:tax',
        'pharmacy:product_2',
        'pharmacy:notes',
        'pharmacy:ward',
        'pharmacy:medipak',
        'pharmacy:phone',
        'pharmacy:email',
        'pharmacy:credits',
        'pharmacy:debit_note',
        'pharmacy:credit_note',
        'pharmacy:debit_note_x',
        'pharmacy:tax_2',
        'pharmacy:batch_2',
        'pharmacy:batch_3',
        'pharmacy:pharmacy',
        'pharmacy:counter',
        'pharmacy:output_vat',
        'pharmacy:vat',
        'pharmacy:debit',
        'pharmacy:credit',
        'pharmacy:credit_x',
        'pharmacy:invoice',
        'pharmacy:batch_control',
        'pharmacy:blind',
        'pharmacy:blind_2',
        'lab:laboratory',
        'lab:radiology',
        'lab:order',
        'lab:study',
        'lab:note',
        'lab:x_order_x',
        'lab:test',
        'lab:antibiotic',
        'lab:tests',
        'lab:panel',
        'lab:panels',
        'lab:instruments',
        'lab:code',
        'lab:hb',
        'lab:haemoglobin',
        'lab:g_dl',
        'lab:cyanmethaemoglobin',
        'lab:loinc_code',
        'lab:cbc',
        'lab:complete_blood_count',
        'lab:bb_marker_hiv',
        'lab:bb_marker_hepatitis_b',
        'lab:bb_marker_hepatitis_c',
        'lab:bb_marker_malaria',
        'lab:wristband',
        'lab:instrument',
        'lab:key',
        'lab:sysmex_xn_550',
        'lab:protocol',
        'lab:hl7_v2_oru_r01',
        'lab:astm_e1394',
        'lab:notes',
        'lab:run_bat_serial_bridge_com_port',
        'lab:run_bat_tcp_relay_bridge_lan_analyser',
        'lab:hgb',
        'lab:format',
        'lab:03xxxxxxxxx',
        'lab:label_printer',
        'lab:ward',
        'lab:tube',
        'lab:hospital_staff',
        'lab:note_2',
        'lab:staff',
        'lab:imaging',
        'lab:lab_reports',
        'lab:orders',
        'lab:mrn',
        'lab:invoice',
        'lab:test_2',
        'lab:print_bridge',
        'lab:printer',
        'lab:flag',
        'lab:analyser',
        'lab:quality_control',
        'lab:lot',
        'lab:sd',
        'lab:lot_2',
        'lab:runs',
        'lab:cv',
        'lab:sd_2',
        'lab:x_x_sd',
        'lab:x_x_lot_x',
        'lab:cobas_e411',
        'lab:code_2',
        'radiology:radiology',
        'radiology:setup',
        'radiology:study',
        'radiology:study_2',
        'radiology:studies',
        'radiology:radiologist',
        'radiology:agent',
        'radiology:code',
        'radiology:import_agent',
        'ipd:discharge',
        'ipd:allergies',
        'ipd:credit',
        'ipd:notes',
        'ipd:vitals',
        'ipd:bp',
        'ipd:spo',
        'ipd:bill',
        'ipd:nursing_note',
        'ipd:shift',
        'ipd:note',
        'ipd:order',
        'ipd:dose',
        'ipd:procedures',
        'ipd:ward',
        'ipd:bed',
        'ipd:consultant',
        'ipd:bed_class',
        'ipd:bed_board',
        'ipd:bed_x',
        'ipd:mrn',
        'ipd:phone',
        'ipd:follow_up',
        'ipd:bill_2',
        'ipd:mlc',
        'ipd:charge',
        'ipd:ward_charges',
        'ipd:doctor',
        'ipd:charge_item',
        'ipd:nurse_station_x',
        'server:err.export_table',
        'server:err.charge_item',
        'server:err.credit_note',
        'server:err.ward_charges',
        'server:err.journal_entry',
        'server:err.doctor_payout',
        'server:err.slip_printer',
        'server:err.staff_member',
        'server:err.care_team_member',
        'server:err.note_template',
        'server:err.rx_set',
        'server:err.stock_batch',
        'server:err.goods_received_note',
        'server:err.purchase_order',
        'server:err.purchase_return',
        'server:err.lab_order',
        'server:err.lab_panel',
        'server:err.lab_test',
        'server:err.clinical_order',
        'server:err.er_case',
        'server:err.control_lot',
        'server:err.radiology_study',
    ],
};
//# sourceMappingURL=module-allowlist.js.map